import { render, staticRenderFns } from "./LeaseSetupNew.vue?vue&type=template&id=23f19b76&scoped=true"
import script from "./LeaseSetupNew.vue?vue&type=script&lang=js"
export * from "./LeaseSetupNew.vue?vue&type=script&lang=js"
import style0 from "./LeaseSetupNew.vue?vue&type=style&index=0&id=23f19b76&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23f19b76",
  null
  
)

export default component.exports